import {DialogBox, DialogBoxProps} from "common/DialogBox"
import DaumPostcode from "react-daum-postcode";

interface SearchAddressBoxProps extends DialogBoxProps {
    handleComplete: (data: KakaoSearchAddressResponse)  => void
}
export const SearchAddressBox = ({show, close, handleComplete}: SearchAddressBoxProps) => {
    return (
        <DialogBox show={show} close={close}>
            <DaumPostcode onComplete={handleComplete}/>
        </DialogBox>
    )
}

export interface KakaoSearchAddressResponse {
    zonecode: string;
    address: string;
    addressEnglish: string;
    addressType: 'R' | 'J';
    userSelectedType: 'R' | 'J';
    noSelected: 'Y' | 'N';
    userLanguageType: 'K' | 'E';
    roadAddress: string;
    roadAddressEnglish: string;
    jibunAddress: string;
    jibunAddressEnglish: string;
    autoRoadAddress: string;
    autoRoadAddressEnglish: string;
    autoJibunAddress: string;
    autoJibunAddressEnglish: string;
    buildingCode: string;
    buildingName: string;
    apartment: 'Y' | 'N';
    sido: string;
    sidoEnglish: string;
    sigungu: string;
    sigunguEnglish: string;
    sigunguCode: string;
    roadnameCode: string;
    bcode: string;
    roadname: string;
    roadnameEnglish: string;
    bname: string;
    bnameEnglish: string;
    bname1: string;
    bname1English: string;
    bname2: string;
    bname2English: string;
    hname: string;
    query: string;
}